import { Stack, Flex, Heading, Text, Divider, Icon, Box, Button } from '@chakra-ui/react';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Link as RouterLink } from 'react-router-dom';

import { IconArrowRight } from 'assets/icons';
import { routePaths } from 'global/routePaths';

const ThankYou: React.FC<unknown> = () => {
  const [t] = useTranslation(['common']);

  useEffect(() => {
    // Add Wistia Video embed
    const script1 = document.createElement('script');
    const script2 = document.createElement('script');
    script1.src = 'https://fast.wistia.com/embed/medias/3sx7zp82qf.jsonp';
    script1.async = true;
    script2.src = 'https://fast.wistia.com/assets/external/E-v1.js';
    script2.async = true;
    document.body.appendChild(script1);
    document.body.appendChild(script2);

    return () => {
      if (script1 && document.body.contains(script1)) {
        document.body.removeChild(script1);
      }
      if (script2 && document.body.contains(script2)) {
        document.body.removeChild(script2);
      }
    };
  }, []);

  return (
    <Stack
      bgGradient="linear(to-b, white 0%, white 35%, primary.500 35%)"
      height="100%"
      minHeight="100vh"
      p={{ base: 4, md: 20 }}
    >
      <Flex justifyContent="center" alignItems="center" flexDirection="column" width="100%" textAlign="center">
        <Heading as="h3" size="2xl">
          {t('common:thankYouForSigningUp!')}
        </Heading>
        <Text color="gray.500" size="md" mt="4" mb={{ base: 8, md: 14 }}>
          {t('common:weHighlyRecommendYouWatchThisVideo')}
        </Text>
        <Box width={{ base: '100%', md: '600px', lg: '800px', xl: '1000px' }}>
          <div
            className="wistia_embed wistia_async_3sx7zp82qf videoFoam=true"
            style={{ height: '100%', width: '100%' }}
          />
        </Box>
        <Divider colorScheme="gray" borderStyle="dashed" mt="12" mb="6" maxWidth="500px" />
        <Button
          variant="link"
          as={RouterLink}
          to={routePaths.dashboard}
          color="white"
          rightIcon={<Icon as={IconArrowRight} mt="0.5" />}
        >
          {t('common:iKnowHowToUseTimeero')}
        </Button>
      </Flex>
    </Stack>
  );
};

export default ThankYou;
